// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2SUD9","range":"MonthRangeSwitch_range__3c-0F","disabled":"MonthRangeSwitch_disabled__NY0_P"};